export enum ServiceEvent {
    Open = 'Service.Open',
}
